export default __webpack_public_path__ + "static/media/ellipse-green.dd65ab89.svg";